export const initialState = {
  eventsList: null,
  eventDetails: null,
  activeEvents:null
};